import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex)

const store = new Vuex.Store({
    state:{
        usernameTop:''
    },
    mutations:{
        newUsername(state,msg){
            state.usernameTop=msg;
        }
    }
})

export default store;


// WEBPACK FOOTER //
// ./src/vuex/store.js